import React, { useState, useEffect } from 'react'
import AllQuestionList from 'components/all_questions/list'
import { Badge, Button, ErrorComponent, Icons, useModal } from '@pankod/refine-antd'
import { useUserContext } from 'context/user'
import { useGetIdentity } from '@pankod/refine-core'
import QuestionSearch from 'components/all_questions/question-search'
import AllQuestionFilter from 'components/filters/allQuestionFilter'
import { ExportQuestionsModal } from 'components/questions/export_questions_modal'
import { UploadQuestions } from '../../components/uploaded_questions/question_import_modal'
import Permissions from 'permissions'
import { UserContext } from 'context/user'

interface QuestionListPageProps {
  workRequestDetails?: any
  request?: any
  qreviewerList?: any
  qapproverList?: any
  updatePercentage?: any
}

export const AllQuestionListPage: React.FC<QuestionListPageProps> = ({
  workRequestDetails,
  request,
  qreviewerList,
  qapproverList,
  updatePercentage,
}) => {
  const { userLastSearch } = useUserContext()
  const [tableSourceData, setTableSourceData] = useState([])
  const [tableStateLoading, setTableStateLoading] = useState<boolean>(false)
  const [limit, setLimit] = useState<number>(10)
  const [totalNumberOfItems, setTotalNumberOfItems] = useState<number>(0)
  const [searchValue, setSearchValue] = useState<string>('')
  const [additionalFilters, setAdditionalFilters] = useState<any>({})
  const [showExportModal, setShowExportModal] = useState(false)
  const { userRole } = useUserContext()
  const { data: user } = useGetIdentity()
  const { modalProps: uploadProps, show: showUpload, close: closeUpload } = useModal()
  const [currentPage, setCurrentPage] = useState<number>(() => {
    const currentPageFromLocalStorage = workRequestDetails?.workrequestId
      ? '1'
      : localStorage.getItem(`allquestions_${user?.id}_${userRole}_page_number`)
    return currentPageFromLocalStorage ? parseInt(currentPageFromLocalStorage) : 1
  })
  //fetching Questions
  const fetchQuestions = async (
    limit: number,
    currentPage: number,
    searchValue: string,
    userRole: string,
    userId: string,
    additionalFilters: any
  ) => {
    try {
      setTableStateLoading(true)
      const rawParams = {
        limit: limit,
        offset: (currentPage - 1) * limit,
        searchValue: searchValue,
        userRole: userRole,
        userId: userId,
        filters: JSON.stringify(!workRequestDetails?.workrequestId ? additionalFilters : { work_request_id: workRequestDetails?.workrequestId }),
      }
      const params = Object.fromEntries(Object.entries(rawParams).map(([key, value]) => [key, String(value)]))
      const queryString = new URLSearchParams(params).toString()
      //development
      // const questionDetails: any = await fetch(`http://localhost:3001/get-questions?${queryString}`)
      const questionDetails: any = await fetch(`${process.env.REACT_APP_BACKEND_URL}/get-questions?${queryString}`)
      const questionData = await questionDetails?.json()
      if (questionData) {
        const questions = questionData?.question || []
        const numberOfItems = questionData?.total || 0
        setTableSourceData(questions)
        setTotalNumberOfItems(numberOfItems)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setTableStateLoading(false)
    }
  }

  //loading
  const handleLoading = (state: boolean) => setTableStateLoading(state)
  //setlimit
  const setLimitValue = (limitValue: number) => setLimit(limitValue)
  //setCurrentPage
  const setCurrentPageValue = (pageNumber: number) => setCurrentPage(pageNumber)
  //setFilters
  const handleFilters = (filters: any) => setAdditionalFilters(filters)
  //handle search
  const handleSearch = (searchValue: string) => setSearchValue(searchValue)

  const handleExportModalOk = () => {
    setShowExportModal(true)
  }
  const handleExportModalCancel = () => {
    setShowExportModal(false)
  }

  useEffect(() => {
    if (user && user?.id) {
      const currentPageFromLocalStorage = workRequestDetails?.workrequestId
        ? '1'
        : localStorage.getItem(`allquestions_${user?.id}_${userRole}_page_number`)
      setCurrentPage(currentPageFromLocalStorage ? parseInt(currentPageFromLocalStorage) : 1)
      const selectedPage = currentPageFromLocalStorage ? parseInt(currentPageFromLocalStorage) : 1
      const updatedSearchValue = userLastSearch?.question ? userLastSearch?.question : searchValue
      fetchQuestions(limit, selectedPage, updatedSearchValue, userRole, user?.id, additionalFilters)
    }
  }, [userRole, user?.id])

  return (
    <>
      {userRole && Permissions.can(userRole).readAny('questions').granted ? (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              {!workRequestDetails?.workrequestId ? <h1 style={{ fontSize: '24px' }}>All Questions</h1> : <h3> Questions Linked: </h3>}
              <Badge count={totalNumberOfItems} style={{ backgroundColor: '#6659FF', marginLeft: '8px' }} overflowCount={9999999} />
            </div>

            {!workRequestDetails?.workrequestId && (
              <div style={{ gap: '1rem' }}>
                <Button icon={<Icons.ExportOutlined />} onClick={handleExportModalOk} style={{ marginLeft: '5px', marginBottom: '5px' }}>
                  Export
                </Button>
                {userRole && (userRole === 'qcreator' || userRole === 'subjectincharge') && (
                  <Button icon={<Icons.UploadOutlined />} onClick={showUpload} style={{ marginLeft: '5px' }}>
                    Upload
                  </Button>
                )}
              </div>
            )}
          </div>
          {/* search functionality */}
          {!workRequestDetails?.workrequestId && (
            <QuestionSearch
              handleSearch={handleSearch}
              setCurrentPageValue={setCurrentPageValue}
              additionalFilters={additionalFilters}
              limit={limit}
              userRole={userRole}
              userId={user?.id}
              fetchQuestions={fetchQuestions}
            />
          )}
          {/* filter */}
          {!workRequestDetails?.workrequestId && (
            <AllQuestionFilter
              handleLoading={handleLoading}
              fetchQuestions={fetchQuestions}
              handleFilters={handleFilters}
              totalNumberOfItems={totalNumberOfItems}
              limit={limit}
              currentPage={currentPage}
              userRole={userRole}
              userId={user?.id}
              tableStateLoading={tableStateLoading}
              searchValue={searchValue}
              additionalFilters={additionalFilters}
              setCurrentPageValue={setCurrentPageValue}
            />
          )}
          {/* question list table */}
          <AllQuestionList
            tableSourceData={tableSourceData}
            handleLoading={handleLoading}
            fetchQuestions={fetchQuestions}
            setLimitValue={setLimitValue}
            setCurrentPageValue={setCurrentPageValue}
            handleFilters={handleFilters}
            handleSearch={handleSearch}
            totalNumberOfItems={totalNumberOfItems}
            limit={limit}
            currentPage={currentPage}
            userRole={userRole}
            userId={user?.id}
            tableStateLoading={tableStateLoading}
            searchValue={searchValue}
            additionalFilters={additionalFilters}
            request={request}
            user={user}
            qreviewerList={qreviewerList}
            qapproverList={qapproverList}
            updatePercentage={updatePercentage}
          />
          <ExportQuestionsModal isModalVisible={showExportModal} handleOk={handleExportModalOk} handleCancel={handleExportModalCancel} />
          <UploadQuestions
            modalProps={uploadProps}
            close={closeUpload}
            reloadUploadedData={() => fetchQuestions(10, 1, '', userRole, user?.id, additionalFilters)}
          />
        </div>
      ) : (
        <>
          <ErrorComponent />
        </>
      )}
    </>
  )
}

// export default AllQuestionListPage

const AllQuestionListPageWrapper = () => {
  return <AllQuestionListPage />
}
export default AllQuestionListPageWrapper
